import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

// @ts-expect-error dependency missing types
import publicRootReducer from '../reducers/public';
// @ts-expect-error dependency missing types
import publicActionCreators from '../actions/public';
// @ts-expect-error dependency missing types
import RavenErrorReportingMiddleware from '../middleware/RavenErrorReportingMiddleware';
export function configureStorePublicApp(initialState) {
  return createStore(publicRootReducer, initialState, compose(applyMiddleware(thunk, RavenErrorReportingMiddleware),
  // @ts-expect-error __REDUX_DEVTOOLS_EXTENSION__ doesn't exist on window
  window.__REDUX_DEVTOOLS_EXTENSION__ ?
  // @ts-expect-error __REDUX_DEVTOOLS_EXTENSION__ doesn't exist on window
  window.__REDUX_DEVTOOLS_EXTENSION__({
    actionCreators: publicActionCreators
  }) : f => f));
}